module.exports = __webpack_public_path__ + "img/wtx-logo.21a2cdf4.png";